import { FiBriefcase, FiBookOpen, FiGlobe } from 'react-icons/fi'
import type { BecLetter } from '@/types/about'

export const becFramework: BecLetter[] = [
  {
    key: 'business',
    letter: 'B',
    title: 'Business (Entrepreneurship)',
    description:
      'Through the Africa Caribbean Young Entrepreneurs and Innovation Hub (AfCa-YEIH), we connect young entrepreneurs across both regions to exchange ideas, develop innovative solutions, and build the networks they need to launch and grow sustainable ventures.',
    Icon: FiBriefcase,
  },
  {
    key: 'education',
    letter: 'E',
    title: 'Education & Leadership',
    description:
      'Through programmes like TUWE (Technical University Women in Entrepreneurship) and the Africa-Caribbean Student-Preneur & Innovation Hub (AfCaSPIH) Nexus, we equip students and emerging leaders with practical knowledge, leadership skills, and the confidence to seize opportunities and become agents of change across the regions we serve.',
    Icon: FiBookOpen,
  },
  {
    key: 'culture',
    letter: 'C',
    title: 'Culture',
    description:
      'The Africa Caribbean Culture Festival (AfCa-CF) celebrates entrepreneurship, creativity, and cultural heritage, bringing together emerging leaders through networking, learning, and shared experiences that connect Africa and the Caribbean.',
    Icon: FiGlobe,
  },
]
